<template>
  <div class="drawer-wapper-info">
    <div class="order-info">
      <div class="main-info">
        <el-descriptions class="margin-top" :column="6" border>
          <el-descriptions-item :labelStyle="{ width: '110px' }" :span="3">
            <template slot="label">
              {{ $l('form_label_salesChannel') || '销售渠道' }}
            </template>
            {{ formData.salesChannel || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :labelStyle="{ width: '110px' }"
            :contentStyle="{ padding: '0' }"
            :span="3"
          >
            <template slot="label">
              {{ $l('form_label_order_status') || '订单状态' }}
            </template>
            <div class="order-status-info">
              <div class="tag">
                <el-tag
                  size="mini"
                  :type="
                    formData.orderStatus === 12 || formData.orderStatus === 13
                      ? 'success'
                      : formData.orderStatus === 11
                      ? 'warning'
                      : formData.orderStatus === 10
                      ? 'primary'
                      : 'danger'
                  "
                >
                  {{ formData.v_orderStatus }}
                </el-tag>
              </div>
              <span class="createType"> {{ formData.v_createType }} </span>
            </div>
          </el-descriptions-item>
          <el-descriptions-item :labelStyle="{ width: '110px' }" :span="3">
            <template slot="label">
              {{ $l('form_label_orderNo') || '渠道订单号' }}
            </template>
            {{ formData.orderNo || '' }}
          </el-descriptions-item>
          <el-descriptions-item :labelStyle="{ width: '110px' }" :span="3">
            <template slot="label">
              {{ $l('form_label_customerOrderNo') || '客户订单号' }}
            </template>
            {{ formData.customerOrderNo || '' }}
          </el-descriptions-item>

          <el-descriptions-item :labelStyle="{ width: '110px' }" :span="3">
            <template slot="label">
              {{ $l('form_label_contact_name') || '收货人' }}
            </template>
            {{ formData.contact || '' }}
          </el-descriptions-item>
          <el-descriptions-item :labelStyle="{ width: '110px' }" :span="3">
            <template slot="label">
              {{ $l('form_label_phone') || '联系电话' }}
            </template>
            {{ formData.phone || '' }}
          </el-descriptions-item>

          <el-descriptions-item :labelStyle="{ width: '110px' }" :span="6">
            <template slot="label">
              {{ $l('form_label_address') || '收货地址' }}
            </template>
            {{ formData.country || '' }} {{ formData.province || '' }}
            {{ formData.city || '' }} {{ formData.district || '' }}
            <span v-if="formData.postalCode">
              ({{ formData.postalCode || '' }})
            </span>
            {{ formData.address1 || '' }}
            {{ formData.address2 || '' }}
            {{ formData.address3 || '' }}
          </el-descriptions-item>

          <el-descriptions-item :labelStyle="{ width: '110px' }" :span="2">
            <template slot="label">
              {{ $l('form_label_amount') || '订单金额' }}
            </template>
            {{ formData.v_amount || '' }}
          </el-descriptions-item>
          <el-descriptions-item :labelStyle="{ width: '110px' }" :span="2">
            <template slot="label">
              {{ $l('INDEX.create_date') || '创建时间' }}
            </template>
            {{ formData.v_createTime || '' }}
          </el-descriptions-item>
          <el-descriptions-item :labelStyle="{ width: '110px' }" :span="2">
            <template slot="label">
              {{ $l('form_label_update_time') || '更新时间' }}
            </template>
            {{ formData.v_modifyTime || '' }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="order-tranck">
        <el-descriptions :column="2" border>
          <el-descriptions-item :labelStyle="{ width: '110px' }">
            <template slot="label">
              {{ $l('form_label_estimatedShipDate') || '预计发货日期' }}
            </template>
            {{ formData.v_estimatedShipDate || '' }}
          </el-descriptions-item>
          <el-descriptions-item :labelStyle="{ width: '110px' }">
            <template slot="label">
              {{ $l('form_label_estimatedDeliveryDate') || '预计到货日期' }}
            </template>
            {{ formData.v_estimatedDeliveryDate || '' }}
          </el-descriptions-item>
          <el-descriptions-item :labelStyle="{ width: '110px' }">
            <template slot="label">
              {{ $l('form_label_shippingMethod') || '配送方式' }}
            </template>
            {{ formData.carrierName || '' }}
          </el-descriptions-item>
          <el-descriptions-item :labelStyle="{ width: '110px' }">
            <template slot="label">
              {{ $l('form_label_tracking_no') || 'Tracking No' }}
            </template>
            {{ formData.trackingNo || '' }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>
    <div class="order-goods-info mt-10">
      <OrderGoodsInfo
        :loading="orderGoodsInfoLoad"
        :tableData="orderGoodsTable"
      ></OrderGoodsInfo>
    </div>
    <el-row :gutter="5" class="mt-10">
      <el-col :span="12">
        <OrderStatusInfo
          :loading="orderStatusInfoLoad"
          :tableData="orderStatusTable"
        ></OrderStatusInfo>
      </el-col>

      <el-col :span="12">
        <OrderChargesInfo
          :loading="orderChargesInfoLoad"
          :tableData="orderChargesTable"
        >
        </OrderChargesInfo>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import OrderGoodsInfo from './orderGoodsInfo'
import OrderChargesInfo from './orderChargesInfo'
import OrderStatusInfo from './orderStatusInfo'
export default {
  components: { OrderGoodsInfo, OrderChargesInfo, OrderStatusInfo },

  props: {
    orderCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      orderGoodsInfoLoad: true,
      orderStatusInfoLoad: true,
      orderChargesInfoLoad: true,
      orderGoodsTable: [],
      orderStatusTable: [],
      orderChargesTable: [],
    }
  },

  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderCode) return
      this.$api
        .ecomOrderDetailApi({
          orderCode: this.orderCode,
        })
        .then((res) => {
          this.formData = { ...res.body }
          this.orderGoodsTable = this.formData.orderGoodsTable || []
          this.orderStatusTable = this.formData.orderStatusTable || []
          this.orderChargesTable = this.formData.orderChargesTable || []
        })
      this.orderGoodsInfoLoad = false
      this.orderStatusInfoLoad = false
      this.orderChargesInfoLoad = false
    },
    cancel() {
      this.close()
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.drawer-wapper-info {
  padding: 0 30px;
}
.order-info {
  margin-bottom: 12px;
  .main-info {
    margin-bottom: 10px;
  }
}
.order-status-info {
  display: flex;
  height: 46px;
  line-height: 46px;
  .tag {
    display: flex;
    align-items: center;
    flex: 50%;
    border-right: 1px solid #efefef;
  }

  .createType {
    flex: 50%;
  }
  span {
    margin-left: 10px;
  }
}
.mt-10 {
  margin-bottom: 10px;
}
</style>
